import { Component, OnInit, OnDestroy, HostListener } from '@angular/core'
import { Store, Actions, ofActionSuccessful, Select } from '@ngxs/store'
import * as _ from 'lodash'
import moment from 'moment'
import { DocumentService } from 'app/services/document.service'
import { WorkoutState } from 'app/state/workout/workout.state'
import { timer, BehaviorSubject, Observable, Subscription, interval } from 'rxjs'
import { PauseWorkout, EndWorkout } from 'app/state'
import { Router } from '@angular/router'
import { WorkoutSession } from 'app/models/workout-session-document.model'
import { PageTransitionService, PAGETRANSITIONS } from 'app/services/page-transition.service'
import { tap } from 'rxjs/operators'

@Component({
  standalone: false,
  selector: 'app-exercise',
  templateUrl: './exercise.component.html',
  styleUrls: ['./exercise.component.scss']
})
export class ExerciseComponent implements OnInit, OnDestroy {
  @Select(WorkoutState.currentExerciseCount) currentExerciseCount$: Observable<number>
  currentWorkoutSession: WorkoutSession
  currentTierIndex: number = 0;
  currentTierIndexSubject: BehaviorSubject<number>;
  currentTierIndex$: Observable<number>;
  totalTime: number
  timeElapsed = '00:00'
  timer$: Subscription
  pollSub: Subscription;

  private startTimeValue: number

  constructor(
    private store: Store,
    private documentService: DocumentService,
    private router: Router,
    private actions$: Actions,
    private pageTransitionService: PageTransitionService,
  ) { }

  ngOnInit() {
    this.currentWorkoutSession = this.store.selectSnapshot(WorkoutState.currentWorkoutSession)
    const tierIndex = this.store.selectSnapshot(WorkoutState.currentWorkoutIndex);
    this.currentTierIndex = tierIndex !== undefined ? tierIndex : 0;
    this.currentTierIndexSubject = new BehaviorSubject<number>(this.currentTierIndex);
    this.currentTierIndex$ = this.currentTierIndexSubject.asObservable();
    this.totalTime = this.store.selectSnapshot(WorkoutState.totalTime)
    this.startTimeValue = new Date(this.currentWorkoutSession.start_time).valueOf()

    // 1 * 1000 === 1s
    this.timer$ = timer(1, 1 * 1000).subscribe((time: number) => {
      const elapsedMs = new Date().valueOf() - this.startTimeValue
      const elapsedMinutes = Math.floor(elapsedMs / 1000 / 60)
      const elapsedSeconds = Math.round(((elapsedMs / 1000 / 60 ) - elapsedMinutes) * 60)

      const minutes = elapsedMinutes.toString().padStart(2, '0')
      const seconds = elapsedSeconds.toString().padStart(2, '0')

      this.timeElapsed = `${minutes}:${seconds}`
    })

    this.actions$.pipe(ofActionSuccessful(EndWorkout)).subscribe(() => {
      this.pageTransitionService.setCurrentAnimation(PAGETRANSITIONS.LEFT)
      this.router.navigate(['/exercise/complete'])
    })

    this.pollSub = interval(30 * 1000).pipe(tap(() => {
      this.documentService.pollServer()
    })).subscribe()
  }

  endWorkout() {
    const elapsedMs = new Date().valueOf() - this.startTimeValue
    this.store.dispatch(new EndWorkout(elapsedMs))
  }

  changeTier(): void {
    const tierIndex = this.store.selectSnapshot(WorkoutState.currentWorkoutIndex);
    this.currentTierIndex = tierIndex !== undefined ? tierIndex : 0;
    this.currentTierIndexSubject.next(this.currentTierIndex);
  }

  ngOnDestroy() {
    this.store.dispatch(new PauseWorkout(this.totalTime))
    this.timer$.unsubscribe()
    this.pollSub.unsubscribe()
  }

  @HostListener('window:beforeunload', [ '$event' ])
  beforeUnloadHander($event) {
    this.store.dispatch(new PauseWorkout(this.totalTime))
    // return $event.returnValue = true
  }

}
